var cookiesLib = require("./cookies");
var i18nLib = require("../i18n");

$(document).ready(function () {
	// Fix current page active class
	if ('URL' in window) {
		var currentUrl = new URL(location.href);
		$('.home-link').removeClass('active');
		$('.as-nav .menu ul li a').removeClass('active');
		$(`.as-nav .menu ul li a[href='${currentUrl.pathname}']`).addClass('active');
	}

	var favorites = getfavoritesTours();
	updateNotificationsCount(favorites.length);

	favoriteTourList(favorites);

	var tourId = $("#tourId").val();
	//    var favorites = cookiesLib.getCookie("favoritesTours") ? cookiesLib.getCookie("favoritesTours").split(",") : [];

	if (favorites.indexOf(tourId) != -1) {
		$("#add-favorite--tour").prop("checked", true);
		$("label[for=add-favorite--tour]").html($("#removeFavorite").val());
		$("label[for=add-favorite--tour]").addClass("add--favorite--button--checked");
	}

	$("#add-favorite--tour").on("click", function () {
		$("#add-favorite--tour").attr("disabled", true);

		favorites = getfavoritesTours();

		var addTour = $("#add-favorite--tour").prop("checked");

		var favoritesLength = favorites.length;
		/* if not exists a favorites in cookie than create a list of favorites in cookie */
		if (addTour && favorites.length == 0) {
			cookiesLib.setCookie('favoritesTours', tourId, 180);
			$("label[for=add-favorite--tour]").html(i18nLib.localize("remove_favorite"));
			$("label[for=add-favorite--tour]").addClass("add--favorite--button--checked");
			favoritesLength++;
		}
		else if (addTour && favorites.indexOf(tourId) == -1) {
			favorites.push(tourId);
			cookiesLib.setCookie('favoritesTours', favorites.join(','), 180);
			$("label[for=add-favorite--tour]").html(i18nLib.localize("remove_favorite"));
			$("label[for=add-favorite--tour]").addClass("add--favorite--button--checked");
			favoritesLength++;
		}
		else if (!addTour) {
			cookiesLib.setCookie('favoritesTours', cookiesLib.getCookie("favoritesTours").replace("," + tourId, "").replace(tourId, ""), 180);
			$("label[for=add-favorite--tour]").html(i18nLib.localize("add_to_favorites"));
			$("label[for=add-favorite--tour]").removeClass("add--favorite--button--checked");
			favoritesLength--;
		}

		if (favoritesLength > 0) {
			if ($(".fav-notification").hasClass("hide")) {
				$(".fav-notification").removeClass("hide");
			}

			$(".fav-notification").html(favoritesLength.toString());
			$(".fav-notification").show();
		}
		else {
			$(".fav-notification").hide();
		}

		$("#add-favorite--tour").attr("disabled", false);
	});

	$('#favoriteForm').submit(function (event) {
		var service = $('#serviceUrl').val();
		$('#returnMessengeDiv').hide();
		$('#submitButton').hide();

		$.ajax({
			url: service,
			type: "GET",
			dataType: 'json',
			data: $(this).serialize(), // serializes the form's elements.
			success: function (data) {
				var returnText;
				if (!data.emailFilled)
					returnText = "<p>" + i18nLib.localize("The e-mail field is empty! Please, put the e-mail and try again.") + "</p>";
				else if (!data.favoritesFilled)
					returnText = "<p>" + i18nLib.localize("There aren't favorites!") + "</p>";
				else if (data.sendedEmail)
					returnText = "<p>" + i18nLib.localize("The e-mail has been successfully sent!") + "</p>";
				else
					returnText = i18nLib.localize("E-mail was not sent! Try again later, please.");

				$('#returnMessenge').html(returnText);
				$('#returnMessengeDiv').show();
				$('#submitButton').show();
				$('.email-field').hide();
			},
			error: function (xhr) {
				console.log(xhr.responseText);
			}
		});
		event.preventDefault();
	});
});

function getfavoritesTours () {
	var favoritesF = [];

	var favorites = cookiesLib.getCookie("favoritesTours") ? cookiesLib.getCookie("favoritesTours").split(",") : [];

	favoritesF = favorites.filter(function (el) {
		return (el && (el.length > 0));
	});

	return favoritesF;
}

function favoriteEventHandler (e) {
	e.preventDefault()
	var favorites = getfavoritesTours();
	var listBtn = e.target.nodeName === 'IMG' ? e.target.parentElement : e.target
	var emptyHeart = listBtn.querySelector('.heart-icon-tour')
	var fullHeart = listBtn.querySelector('.heart-icon-tour-red')
	var tourId = listBtn.attributes
		&& listBtn.attributes['tour-id']
		&& listBtn.attributes['tour-id'].value

	var addTour = !checkFavsIsRed(fullHeart);

	var favoritesLength = favorites.length;
	/* if not exists a favorites in cookie than create a list of favorites in cookie */
	if (addTour && favorites.length == 0) {
		cookiesLib.setCookie('favoritesTours', tourId, 180);
		favoritesLength++;
		turnFavRed(emptyHeart, fullHeart);
	}
	else if (addTour && favorites.indexOf(tourId) == -1) {
		favorites.push(tourId);
		cookiesLib.setCookie('favoritesTours', favorites.join(','), 180);
		favoritesLength++;
		turnFavRed(emptyHeart, fullHeart);
	}
	else if (!addTour) {
		cookiesLib.setCookie('favoritesTours', cookiesLib.getCookie("favoritesTours").replace("," + tourId, "").replace(tourId, ""), 180);
		favoritesLength--;
		turnFavBlue(emptyHeart, fullHeart);
	}

	updateNotificationsCount(favoritesLength)

}

// Below this point is the favorite button related to "tour-list" layout
function favoriteTourList (fav) {
	var favorites = fav || getfavoritesTours();
	const tourListButtons = document.querySelectorAll('.tour-list-intro-favorite')

	for (const divBtn of tourListButtons) {
		const tourId = divBtn.attributes
			&& divBtn.attributes['tour-id']
			&& divBtn.attributes['tour-id'].value

		let listBtn = divBtn.querySelector('.tour-list-favorites-down')
		let emptyHeart = divBtn.querySelector('.heart-icon-tour')
		let fullHeart = divBtn.querySelector('.heart-icon-tour-red')

		// For some reason without the timeout these functions were not working
		setTimeout(function () {
			if (favorites.indexOf(tourId) != -1) {
				turnFavRed(emptyHeart, fullHeart);
			} else {
				turnFavBlue(emptyHeart, fullHeart);
			}
		}, 500)

		if (listBtn) {
			listBtn.removeEventListener('click', favoriteEventHandler)
			listBtn.addEventListener('click', favoriteEventHandler)
		}
	}
	bLazy.revalidate()
}

let turnFavRed = function (emptyHeart, fullHeart) {
	if (!emptyHeart || !fullHeart) return

	emptyHeart.classList.add("hidden")
	fullHeart.classList.remove("hidden")
};

let turnFavBlue = function (emptyHeart, fullHeart) {
	if (!emptyHeart || !fullHeart) return

	emptyHeart.classList.remove("hidden")
	fullHeart.classList.add("hidden")
};

let checkFavsIsRed = function (fullHeart) {
	if (!fullHeart) return

	return !fullHeart.classList.contains("hidden")
};

let updateNotificationsCount = function (favoritesLength) {
	if (!favoritesLength) return

	if (favoritesLength > 0) {
		if ($(".fav-notification").hasClass("hide")) {
			$(".fav-notification").removeClass("hide");
		}

		$(".fav-notification").html(favoritesLength.toString());
		$(".fav-notification").show();
	}
	else {
		$(".fav-notification").hide();
	}
}

module.exports = {
	favoriteTourList: favoriteTourList
}



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/favorite.js